<template>
  <div>
    <button class="btn btn-primary" @click="modalShow = !modalShow">+ Add New</button>

    <b-modal v-model="modalShow" title="Add New Brand">
      <p class="mb-0">Name</p>
      <b-form-input
        id="input-small"
        size="sm"
        :placeholder="`Enter Brand name`"
        v-model="name"
      ></b-form-input>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="danger" @click="cancel()"> Cancel </b-button>
        <b-button size="sm" variant="primary" @click="trigerSave"> Save</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["placeholder"],
  data() {
    return {
      modalShow: false,
      name: "",
    };
  },
  methods: {
    trigerSave() {
      this.modalShow = false;
      this.name !== "" ? this.$emit("save", this.name) : null;
    },
  },
};
</script>
